import React, { Component } from "react";
import "./membernew.scss?v=2024";
import { Toast, WhiteSpace, WingBlank, Button } from "antd-mobile";
import Uheader from "../Goolbal/Uheader";
import jindou from "../assets/jindou.png";
import gongnneg from "../assets/gongnneg.png";
import check from "../assets/check.png";
import close from "../assets/close.png";
import axios from "../axios";

var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

class member extends React.Component {
  state = {
    Package: [
      // {
      //   costPrice: "48",
      //   discount: "1",
      //   nowPrice: "48",
      //   payValid: "3",
      //   title: ""
      // },
    ],
    privilege: [

    ],
    memberInfo: {},  //用户信息
    gradePriceInfo: [], //会员等级信息
    beanDiscount:'',  //钱豆支付比例
    gradeType:'', //购买会员类型
    promptMsg: [],  //会员等级提示语
    memberType: '1',
    footList: [
      {
        Amount: "累计充值积分",
        grade: "会员等级",
        discount: "金豆购买折扣",
      },
      {
        Amount: "0~665积分",
        grade: "白银",
        discount: "9.8折",
      },
      {
        Amount: "666~1687积分",
        grade: "黄金",
        discount: "9.5折",
      },
      {
        Amount: "1688~5188积分",
        grade: "钻石",
        discount: "9.2折",
      },
      {
        Amount: "5188积分以上",
        grade: "皇冠",
        discount: "8.8折",
      },
    ],
    assets: [
      //资产
      {
        img: jindou,
        title: "金豆",
        content: "剩余：0",
        btn: "我的金豆",
      },
      {
        img: gongnneg,
        title: "功能券",
        content: "匿名、标题变色、闪买、闪卖、置顶等会员专享功能",
        btn: "我的功能券",
      },
    ],
    MemberPackage: {},
    tab: "tab-0", //选中颜色高亮Package
    Mymember: true, //是否是会员
    resultObject: {}, //接口信息哦
    userimgUrl: null,
    checkTotalVisible: false, //充值金额累计弹窗标识
    checkRuleVisible: false, //会员有效期弹窗标识
  };
  Discoloration = (item, key) => {
    console.log(item, key);
    this.setState({
      tab: `tab-${key}`,
      MemberPackage: item,
    });
  };

  checkTotal = () => {
    this.setState({
      checkTotalVisible: true
    });
  };

  checkRule = () => {
    this.setState({
      checkRuleVisible: true
    });
  };

  closeDialog = () => {
    this.setState({
      checkRuleVisible: false,
      checkTotalVisible: false,
    });
  };

  changeMemberType = (type) => {
    let grade = this.state.gradePriceInfo[Number(type) - 1],
      data = grade.couponList;
    var yearList = []
    for (let i = 0; i < data.length; i++) {
      let obj = data[i];
      console.log(obj)
      obj.json = JSON.parse(obj.jsonStr)
      yearList.push(obj);
    }

    this.setState({
      memberType: type,
      Package: grade.priceList,
      promptMsg: grade.promptMsg.split(';'),
      privilege: yearList,
      tab: `tab-0`,
      MemberPackage: grade.priceList[0],
      beanDiscount: grade.beanRate,
      gradeType: grade.grade,
    })
  };

  MymemberClick = () => {
    //  console.log(u)
    var arr = Object.keys(this.state.MemberPackage);
    if (!arr.length) {
      // return;
      Toast.fail("请选择套餐内容", 2);
      return;
    }
    console.log(this.state.MemberPackage);
    if (this.state.Mymember === true) {
      let obj = {
        code: this.state.MemberPackage.month, //月数
        Quantity: this.state.MemberPackage.price, //金额
        beanCount: `${this.state.memberInfo.totalBean}`, //个人金豆数量
        beanPrice: `${this.state.memberInfo.beanPrice}`, //钱都换算比例
        beanDiscount: `${this.state.beanDiscount}` || '0',//钱豆混合的比例
        grade: `${this.state.gradeType}`,//购买会议类型
        payway: (this.state.beanDiscount && this.state.beanDiscount > 0) ? "2" : "1", //1钱 2钱豆   支付方式
      };
      console.log("会员", obj);
      let MYdata = JSON.stringify(obj);
      if (isiOS) {
        try {
          window.webkit.messageHandlers.IOSNativeBuyMember.postMessage(obj);
        } catch (e) {
          console.log(e);
          setTimeout(function () {
            Toast.fail("请升级最新版本,当前版本过低暂不支持此功能", 3);
          }, 2000);
        }
      } else {
        try {
          window.app.androidBuyMembership(MYdata);
          // this.setState({
          //   Show: "none"
          // });
        } catch (e) {
          //TODO handle the exception
          // console.log(e);
          setTimeout(function () {
            Toast.fail("请升级最新版本,当前版本过低暂不支持此功能", 3);
          }, 2000);
        }
      }
    } else {
      let obj = {
        code: this.state.MemberPackage.month,
        Quantity: this.state.MemberPackage.price,
        beanCount: `${this.state.memberInfo.totalBean}`,
        beanPrice: `${this.state.memberInfo.beanPrice}`,
        beanDiscount: `${this.state.beanDiscount}` || '0',//钱豆混合的比例
        grade: `${this.state.gradeType}`,//购买会议类型
        payway: (this.state.beanDiscount && this.state.beanDiscount > 0) ? "2" : "1", //1钱 2钱豆   支付方式
      };
      // console.log("不是会员",obj);
      let MYdata = JSON.stringify(obj);
      if (isiOS) {
        try {
          window.webkit.messageHandlers.IOSNativeBuyMember.postMessage(obj);
          // window.webkit.messageHandlers.IOSNativePayBond.postMessage(50);
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          window.app.androidBuyMembership(MYdata);
        } catch (e) {
          console.log(e);
        }
      }
    }
  };

  gotoMemberAgreement =() =>{
    window.open('http://app.youbao360.com/h5/newHelpcenter/memberAgreement.html','_blank');
  }

  BuyGoldBean = (item, key) => {
    console.log(item, key);
    if (key === 0) {
      //购买金豆
      if (isiOS) {
        try {
          window.webkit.messageHandlers.IOSNativeBuyGoldBean.postMessage("");
          // window.webkit.messageHandlers.IOSNativePayBond.postMessage(50);
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          window.app.androidBuyGoldBean("");
        } catch (e) {
          console.log(e);
        }
      }
    } else {
      //我的功能卷
      if (isiOS) {
        try {
          window.webkit.messageHandlers.IOSNativeBuyFunctionBond.postMessage(
            ""
          );
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          window.app.androidGotoFunctionTicket("");
        } catch (e) {
          console.log(e);
        }
      }
    }
  };
  /**获取网址参数 */
  getUrlParam = (name) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = this.props.location.search.substr(1).match(reg);
    if (r != null) {
      return decodeURI(r[2]);
    }
    return ""; //如果此处只写return;则返回的是undefined
  };
  onClose = () => { };
  componentWillMount() {
    sessionStorage.setItem("Authorization",this.getUrlParam('tokenHead')+' '+this.getUrlParam('tokenCode'))
  }
  
  // js比较两个数组对象,取出key相同的并push进同一数组

  componentDidMount() {
    //DOM加载完执行 类似于mounted
    const _this = this;
    axios
      .post("/user/json/getMemberInfoV2?userId=" + _this.props.match.params.userId, {
      }).then(function (response) {
        console.log(response)
        if (response.data.code === 10000) {
          // userType 2- 已经认证,未开通会员     1-注册 3-白银4-黄金5-钻石6-皇冠

          let userType, userimgUrl;
          if (
            response.data.resultObject.memberInfo.userType === "1" ||
            response.data.resultObject.memberInfo.userType === "2"
          ) {
            userType = false; //不是会员
          } else {
            userType = true; //会员
            if (response.data.resultObject.memberInfo.userType == 3) {
              userimgUrl = require("../assets/silver.png");
            } else if (response.data.resultObject.memberInfo.userType == 4) {
              userimgUrl = require("../assets/gold.png");
            } else if (response.data.resultObject.memberInfo.userType == 5) {
              userimgUrl = require("../assets/diamond.png");
            } else if (response.data.resultObject.memberInfo.userType == 6) {
              userimgUrl = require("../assets/Crown.png");
            }
          }

          let data = response.data.resultObject.gradePriceInfo[0].couponList
          var yearList = []
          for (let i = 0; i < data.length; i++) {
            let obj = data[i];
            // console.log(obj)
            obj.json = JSON.parse(obj.jsonStr)
            yearList.push(obj);
          }

          _this.setState({
            memberInfo: response.data.resultObject.memberInfo,
            gradePriceInfo: response.data.resultObject.gradePriceInfo,
            promptMsg: response.data.resultObject.gradePriceInfo[0].promptMsg.split(';'),
            Package: response.data.resultObject.gradePriceInfo[0].priceList,
            privilege: yearList,
            MemberPackage: response.data.resultObject.gradePriceInfo[0].priceList[0],
            beanDiscount: response.data.resultObject.gradePriceInfo[0].beanRate,
            gradeType: response.data.resultObject.gradePriceInfo[0].grade,
            assets: [
              //资产
              {
                img: jindou,
                title: "金豆",
                content: `剩余：${response.data.resultObject.memberInfo.totalBean}`,
                btn: "购买金豆",
              },
              {
                img: gongnneg,
                title: "功能券",
                content: "匿名、标题变色、闪买、闪卖、置顶等会员专享功能",
                btn: "我的功能券",
              },
            ],
            Mymember: userType,
            userimgUrl: userimgUrl,
          });

        } else {
          _this.setState({
            isLoaded: false,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });

  }
  render() {

    return (
      <div className="mymember">
        {/* <Uheader utitle="会员信息"></Uheader> */}
        <header>
          <div className="header_home">
            <div className="header_left">
              <img
                src={
                  this.state.memberInfo.portrait ||
                  "http://image.ybk008.com/2442e653c60be98c37a2945b6015e941571110502565"
                }
                className="userAvatar"
              />
              <ul>
                <li>
                  <h1>
                    {this.state.memberInfo.nickName}
                    {this.state.Mymember ? (
                      <img src={this.state.userimgUrl} alt="" />
                    ) : null}
                  </h1>

                  {/* <div className="Grand">累计充值金额 <span className="geandBox" onClick={() => this.checkTotal()}>?</span></div> */}
                </li>
                <li>
                  <p>当前会员身份：{this.state.memberInfo.membership}</p>

                  {/* <p className="Amount">
                    ￥<span>{this.state.memberInfo.statsAmount}</span>
                  </p> */}
                </li>
                <li>
                  <p>{this.state.memberInfo.userValid} 购买后顺延有效期 <span className="geandBox" onClick={() => this.checkRule()}>?</span></p>
                  <p>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </header>

        {this.state.checkRuleVisible ? (
          <div className="dialogModal">
            <div className="dialogMain">
              <div className="dialogTitle">会员有效期规则 <span className="closeIcon" onClick={() => { this.closeDialog() }}>×</span></div>
              <div className="dialogCon">
                如您同时购买了多种不同身份的VIP会员套餐，会依次消耗旗舰店VIP会员、超级SVIP会员、VIP会员的有效期天数，享受对应的权益。在您购买超级SVIP会员后，若账号内仍有剩余未过期的VIP会员，将会先立即生效超级SVIP会员权益，剩余的VIP会员到期时间将顺延，待超级SVIP会员过期时继续依次生效。
              </div>
            </div>
          </div>
        ) : null}

        {this.state.checkTotalVisible ? (
          <div className="dialogModal">
            <div className="dialogMain">
              <div className="dialogTitle">会员充值优惠 <span className="closeIcon" onClick={() => { this.closeDialog() }}>×</span></div>
              <div className="dialogCon">
                <footer>
                  <ul>
                    {this.state.footList.map((item, key) => (
                      <li key={key + 100010}>
                        <p>{item.Amount}</p>
                        <p>{item.grade}</p>
                        <p>{item.discount}</p>
                      </li>
                    ))}
                  </ul>
                </footer>
                <p className="user_message">注: 1积分 等于 1元</p>
              </div>
            </div>
          </div>
        ) : null}

        <main>
          {
            this.state.gradePriceInfo.length > 0 ? (
              <div className="Membership" >
                <div className={this.state.memberType == '1' ? "MembershipTabVip MembershipTab" : this.state.memberType == '2' ? "MembershipTabSvip MembershipTab" : this.state.memberType == '3' ? "MembershipTabFlagship MembershipTab" : "MembershipTab"}>
                  {this.state.gradePriceInfo.map((item, index) => (
                    <button key={index + 50} onClick={() => this.changeMemberType(index + 1 + '')} className={(this.state.memberType == '1' && index == 0) ? "btn activeBtn" : (this.state.memberType == '2' && index == 1) ? "btn activeSvipBtn" : (this.state.memberType == '3' && index == 2) ? "btn activeFlagshipBtn" : "btn"}>
                      {item.title}
                    </button>
                  ))}
                </div>
                <ul className={this.state.memberType == '1' ? "vipUl" : this.state.memberType == '2' ? "svipUl" : this.state.memberType == '3' ? "flagshipUl" : ""}>
                  {this.state.Package.map((item, key) => (
                    <li
                      key={key + 150}
                      className={this.state.tab === `tab-${key}` ? "active" : null}
                      onClick={() => this.Discoloration(item, key)}
                    >
                      <p>{item.month == 3 ? '季卡' : item.month == 12 ? '年卡' : (item.month + '个月')}</p>
                      {/* <div className="price"> */}
                        <p>
                          <span>￥<span>{item.price}</span></span>
                          {/* <span>元</span> */}
                        </p>

                        {item.price < item.origPrice ? (
                          // <p className={key === 0 ? "Myhide" : null}>
                          <p>
                            原价:{item.origPrice}元
                          </p>
                        ) : <p className={key === 0 ? "Myhide" : null}>
                        </p>}

                      {/* </div> */}
                      {(item.title && item.discount < 1) ? (
                        <div className="beijing">{item.title}</div>
                      ) : null}
                      {item.discount < 1 ? (
                        <p className="discount">{item.discount * 10}折</p>
                      ) : null}
                    </li>
                  ))}
                </ul>
                <div className="memberHint">
                  {this.state.promptMsg.map((ite, index) => (
                    <p key={index + 200}>{ite}</p>
                  ))}
                </div>

                <button onClick={() => this.MymemberClick()} className={this.state.memberType == '1' ? "btn activeBtn" : this.state.memberType == '2' ? "btn activeSvipBtn" : this.state.memberType == '3' ? "btn activeFlagshipBtn" : ""}>
                  {this.state.Mymember ? "会员续费" : "开通会员"}
                </button>
                <div className="greement_div">
                  <p className="greement_content"> 开通即表示已阅读并同意：<span className="agreementSpan" onClick={() =>this.gotoMemberAgreement()}>《邮宝会员服务协议》</span></p>
                </div>
              </div>
            ) : null
          }

          <div className={this.state.privilege.length <= 3 ? 'privilege' : 'adaptive adaptiveLi'}>
            <p className="privilege_title">会员特权</p>
            <p className="privilege_content">
              充值会员即送海量功能券、金豆最高可享受：<span>8.8折</span>
            </p>
            <ul className={this.state.memberType == '1' ? "btn activeBtn" : this.state.memberType == '2' ? "btn activeSvipBtn" : this.state.memberType == '3' ? "btn activeFlagshipBtn" : ""}>
              {this.state.privilege.map((item, key) => (
                <li key={key + 100}>
                  <p>{item.month == 3 ? '季卡' : item.month == 12 ? '年卡' : (item.month + '个月')}</p>
                  <div>{Object.keys(item.json).map(key => (
                    <nav key={key}>{key == 'anon' ? `匿名${item.json[key]}次` : key == 'light' ? `标题变色${item.json[key]}次` : key == 'fbuy' ? `闪买${item.json[key]}次` : key == 'fsell' ? `闪卖${item.json[key]}次` : key == 'stop' ? `置顶${item.json[key]}次` : item.json[key]}</nav>
                  ))}</div>
                </li>
              ))}
            </ul>
          </div>
          {/* {this.state.Mymember ? ( */}
            <div className="user_assets">
              <p className="user_assets_title">我的资产</p>
              <ul>
                {this.state.assets.map((item, key) => (
                  <li key={key + 11105}>
                    <div className="user_left">
                      <img src={item.img} alt="" />
                      <div>
                        <p>{item.title}</p>
                        <p>{item.content}</p>
                      </div>
                    </div>
                    <div className="user_right">
                      <button onClick={() => this.BuyGoldBean(item, key)}>
                        {item.btn}
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          {/* // ) : null} */}

          {/* <footer>
            <ul>
              {this.state.footList.map((item, key) => (
                <li key={key + 100010}>
                  <p>{item.Amount}</p>
                  <p>{item.grade}</p>
                  <p>{item.discount}</p>
                </li>
              ))}
            </ul>
          </footer>
          <p className="user_message">注: 1积分 等于 1元</p> */}
          {/* <div className="user_assets">
            <p className="user_assets_title">会员权限表</p>
            <div className="purviewBox">
              <table className="purviewTable" border="1" cellSpacing="0" width='100%'>
                <thead>
                  <tr className="tableHead">
                    <td colSpan="2"></td>
                    <td>注册用户</td>
                    <td>认证用户</td>
                    <td> &nbsp;&nbsp;VIP&nbsp;&nbsp; </td>
                    <td> &nbsp;&nbsp;SVIP&nbsp;&nbsp; </td>
                    <td>旗舰店</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowSpan="10">普<br />通<br />功<br />能</td>
                    <td >商品列表</td>
                    <td> <img src={check} /> </td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                  </tr>
                  <tr>
                    <td >商品详情</td>
                    <td> <img src={check} /> </td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                  </tr>
                  <tr>
                    <td >商品详情 <br />(对手盘)</td>
                    <td> <img src={check} /> </td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                  </tr>
                  <tr>
                    <td >行情列表</td>
                    <td colSpan="2"> 不显示价格</td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                  </tr>
                  <tr>
                    <td >邮币卡目录</td>
                    <td> <img src={check} /> </td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                  </tr>
                  <tr>
                    <td >搜索</td>
                    <td> <img src={check} /> </td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                  </tr>
                  <tr>
                    <td >产品详情</td>
                    <td> <img src={check} /> </td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                  </tr>
                  <tr>
                    <td >发布买盘</td>
                    <td> <img src={check} /> </td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                  </tr>
                  <tr>
                    <td >发布卖盘</td>
                    <td> <img src={check} /> </td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                  </tr>
                  <tr>
                    <td >交易</td>
                    <td> <img src={check} /> </td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                  </tr>
                  <tr>
                    <td rowSpan="6">会<br />员<br />功<br />能</td>
                    <td >行情详情<br />(历史行情)</td>
                    <td colSpan="2"> 查看扣豆</td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                  </tr>
                  <tr>
                    <td >匿名交易</td>
                    <td> <img src={close} /> </td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                  </tr>
                  <tr>
                    <td >帖子高光</td>
                    <td> <img src={close} /> </td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                  </tr>
                  <tr>
                    <td >闪买</td>
                    <td> <img src={close} /> </td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                  </tr>
                  <tr>
                    <td >闪卖</td>
                    <td> <img src={close} /> </td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                  </tr>
                  <tr>
                    <td >帖子置顶</td>
                    <td> <img src={close} /> </td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                    <td><img src={check} /></td>
                  </tr>
                 <tr>
                    <td >提现手续费</td>
                    <td> <img src={close}/> </td>
                    <td>1%</td>
                    <td>0.5%</td>
                    <td>免</td>
                    <td>免</td>
                  </tr>
                  <tr>
                    <td rowSpan="2">旗舰店<br />特权</td>
                    <td >买卖盘<br />店铺展示</td>
                    <td> <img src={close} /> </td>
                    <td><img src={close} /></td>
                    <td><img src={close} /></td>
                    <td><img src={close} /></td>
                    <td><img src={check} /></td>
                  </tr>
                  <tr>
                    <td >商品详情<br />推荐展示</td>
                    <td> <img src={close} /> </td>
                    <td><img src={close} /></td>
                    <td><img src={close} /></td>
                    <td><img src={close} /></td>
                    <td><img src={check} /></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> */}
        </main>

        <div className="zhanwei"></div>
      </div>
    );
  }
}
export default member;
